export default {
    userToken: {
        //id
        userId: 'B8197D3E-3999-4E70-973A-17E973D199FF',
        userName: 'dragon',
    },
    userInfo: {}
}


// WEBPACK FOOTER //
// ./src/common/loginInfo.js